export default __webpack_public_path__ + "static/media/userCourses.24fb725a.svg";